import moment from 'moment-timezone';
import { TTBStatus, TTBTableDataType, TTB_TIME, TTB_WARNING } from '../../types/tryThenBuy';

export const getProductNameFromHeadModel = (data: any) => {
  try {
    const modelInfo = data?.selectedNodes?.find((item: any) => item.name === 'Model');
    if (!modelInfo) return '';
    return modelInfo?.option?.name || modelInfo?.option?.info?.name;
  } catch (error) {
    return '';
  }
};

export const getProductImageUrlFromSelectNodes = (data: any) => {
  try {
    const modelInfo = data?.selectedNodes?.find((item: any) => item.name === 'Model');
    if (!modelInfo) return '';
    return (
      modelInfo?.option?.imageURL ||
      modelInfo?.option?.info?.imageUrl ||
      modelInfo?.option?.info?.imageUrlLarge ||
      modelInfo?.option?.info?.imageUrlMedium ||
      modelInfo?.option?.info?.imageUrlSmall
    );
  } catch (error) {
    return '';
  }
};

export const getDetectionHighlightTTB = (record: TTBTableDataType) => {
  const { status, shippedAt, deliveredAt, GVCReturnProductReceivedAt, startedAt, scheduledArrivalDate } = record;
  if (!status) {
    return TTB_WARNING.ORIGINAL;
  }
  const now = moment();
  if (status === TTBStatus.INITIALIZED) {
    const { createdAt } = record;
    if (!scheduledArrivalDate) {
      if (moment(createdAt).add(TTB_TIME.AFTER_INITIALIZED_WARNING_RED, 'days').isBefore(now)) {
        return TTB_WARNING.RED;
      }
      if (moment(createdAt).add(TTB_TIME.AFTER_INITIALIZED_WARNING_ORG, 'days').isBefore(now)) {
        return TTB_WARNING.ORG;
      }
    } else if (scheduledArrivalDate && !shippedAt) {
      if (moment(scheduledArrivalDate).add(TTB_TIME.AFTER_INITIALIZED_WARNING_RED, 'days').isBefore(now)) {
        return TTB_WARNING.RED;
      }
      if (moment(scheduledArrivalDate).add(TTB_TIME.AFTER_INITIALIZED_WARNING_ORG, 'days').isBefore(now)) {
        return TTB_WARNING.ORG;
      }
    }
  }

  if (status === TTBStatus.TRIAL_COMING) {
    if (!deliveredAt && shippedAt) {
      if (moment(shippedAt).add(TTB_TIME.AFTER_TRIAL_COMING_WARNING_RED, 'days').isBefore(now)) {
        return TTB_WARNING.RED;
      }
      if (moment(shippedAt).add(TTB_TIME.AFTER_TRIAL_COMING_WARNING_ORG, 'days').isBefore(now)) {
        return TTB_WARNING.ORG;
      }
    }
  }

  if (status === TTBStatus.PRODUCT_RETURNING) {
    if (moment(startedAt).add(TTB_TIME.AFTER_PRODUCT_RETURNING_WARNING_RED, 'days').isBefore(now)) {
      return TTB_WARNING.RED;
    }
    if (moment(startedAt).add(TTB_TIME.AFTER_PRODUCT_RETURNING_WARNING_ORG, 'days').isBefore(now)) {
      return TTB_WARNING.ORG;
    }
  }

  if (status === TTBStatus.PRODUCT_RECEIVED) {
    if (moment(GVCReturnProductReceivedAt).add(TTB_TIME.AFTER_PRODUCT_RECEIVED_WARNING_RED, 'days').isBefore(now)) {
      return TTB_WARNING.RED;
    }
    if (moment(GVCReturnProductReceivedAt).add(TTB_TIME.AFTER_PRODUCT_RECEIVED_WARNING_ORG, 'days').isBefore(now)) {
      return TTB_WARNING.ORG;
    }
  }

  return TTB_WARNING.ORIGINAL;
};
